
export const BlueIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='37'
    height='22'
    fill='none'
    viewBox='0 0 37 22'
  >
    <path
      fill='#EBF1F8'
      d='M2.533 0h32.023c.534 0 1.047.214 1.424.596.378.38.59.898.59 1.437v17.761c0 .54-.212 1.056-.59 1.438-.377.381-.89.595-1.424.595H2.533a2 2 0 0 1-1.425-.595 2.04 2.04 0 0 1-.59-1.438V2.034c0-.54.212-1.057.59-1.438C1.486.214 1.998 0 2.533 0'
    />
    <path
      fill='#0079BF'
      d='M19.948 20.254a9.2 9.2 0 0 0 3.573-.61 9.2 9.2 0 0 0 3.066-1.946 9.3 9.3 0 0 0 2.09-2.987 9.41 9.41 0 0 0-1.78-10.251 9.3 9.3 0 0 0-2.971-2.092 9.2 9.2 0 0 0-3.634-.782h-5.166a9.2 9.2 0 0 0-6.427 2.797 9.38 9.38 0 0 0-2.647 6.537A9.38 9.38 0 0 0 8.7 17.457a9.2 9.2 0 0 0 6.427 2.797z'
    />
    <path
      fill='#fff'
      d='M15.188 19.495c4.689 0 8.49-3.836 8.49-8.568s-3.801-8.568-8.49-8.568c-4.69 0-8.491 3.836-8.491 8.568s3.801 8.567 8.49 8.567'
    />
    <path
      fill='#0079BF'
      d='M13.328 15.99a5.35 5.35 0 0 1-2.5-1.979 5.43 5.43 0 0 1 0-6.122 5.35 5.35 0 0 1 2.5-1.979zM17.2 15.99a5.35 5.35 0 0 0 2.5-1.979 5.43 5.43 0 0 0 0-6.122 5.35 5.35 0 0 0-2.5-1.979z'
    />
  </svg>
);

